require('./dist/angular-storage.js');
module.exports = 'angular-storage';

